export default __webpack_public_path__ + "static/media/SourceSerifPro-ExtraLightItalic.e4631085.ttf";